export default {
    state: {
        modals: [
            {name: "AddHouse", active: false},
            {name: "DeleteHouse", active: false},
            {name: "AddFlat", active: false},
            {name: "AddIntercom", active: false},
            {name: "UpdateIntercom", active: false},
            {name: "Error", active: false}
        ],
        houseForDelete: null,
        updateIntercomID: null,
        errorMessage: null
    },
    mutations: {
        changeShowModal(state, name) {
            for (let i = 0; i < state.modals.length; i++) {
                if (state.modals[i].name == name) {
                    state.modals[i].active = !state.modals[i].active
                }
            }
        },
        setShowModal(state, {name, val}) {
            for (let i = 0; i < state.modals.length; i++) {
                if (state.modals[i].name == name) {
                    state.modals[i].active = val
                }
            }
        },
        setHouseForDelete(state, id) {
            state.houseForDelete = id
        },
        setUpdateIntercomID(state, id) {
            state.updateIntercomID = id
        },
        setErrorMessage(state, val) {
            state.errorMessage = val
        },
        closeAllModals(state) {
            for (let i = 0; i < state.modals.length; i++) {
                state.modals[i].active = false
            }
        }
    },
    getters: {
        ModalIsActive: (state) => (name) => {
            for (let i = 0; i < state.modals.length; i++) {
                if (state.modals[i].name == name) {
                    return state.modals[i].active
                }
            }
            return false
        },
        ThereIsActiveModal(state) {
            for (let i = 0; i < state.modals.length; i++) {
                if (state.modals[i].active) {
                    return true
                }
            }
            return false
        },
        houseForDelete(state) {
            return state.houseForDelete
        },
        updateIntercomID(state) {
            return state.updateIntercomID
        },
        errorMessage(state) {
            return state.errorMessage
        }
    }
}